module.exports = "#version 300 es\nprecision highp float;\n\nin vec4 fs_Pos;\nin vec4 fs_Nor;\nin vec4 fs_Col;\nin vec2 fs_UV;\n\nvoid main() {\n \n   \n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/shaders/dummy-frag.glsl
// module id = 3
// module chunks = 0